import * as _CookieValueGetters from "./cookie-persisted-value-getters.js";
import * as _UserPreferenceValueGetters from "./user-preference-value-getters.js";
import * as _OtherValueGetters from "./other-value-getters.js";

const CookieValueGetters = { ..._CookieValueGetters };
type CookieValueGetters = typeof CookieValueGetters;

const UserPreferenceValueGetters = { ..._UserPreferenceValueGetters };
type UserPreferenceValueGetters = typeof UserPreferenceValueGetters;

const OtherValueGetters = { ..._OtherValueGetters };
type OtherValueGetters = typeof OtherValueGetters;


function createValueGettersObj ()
{
  return Object.freeze({
    ...CookieValueGetters,
    ...UserPreferenceValueGetters,
    ...OtherValueGetters
  });
}

export type ValueGetters = ReturnType<typeof createValueGettersObj>;
export const ValueGetters = ((window as any).__Mc_ValueGetters ?? createValueGettersObj()) as ValueGetters;

if (!("__Mc_ValueGetters" in window)) {
  (window as any).__Mc_ValueGetters = ValueGetters;
}